jQuery(document).ready(function() {

    gsap.registerPlugin(ScrollTrigger);

    var images = gsap.utils.toArray('.img-parallax');
    var mm = gsap.matchMedia();
    mm.add("(min-width: 768px)", () => {
        images.forEach(image => {
            gsap.fromTo(image, {
                backgroundPosition: () => `50% 90%`
            }, {
                backgroundPosition: () => `50% 10%`,
                ease: "none",
                scrollTrigger: {
                    trigger: image,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true,
                    invalidateOnRefresh: true // to make it responsive
                }
            })
        })
    });

});